// extracted by mini-css-extract-plugin
export var dataCell = "_l2-2";
export var dataRow = "_l2-0";
export var headerRow = "_l2-1";